import React from 'react';
import SuperChart from '@nile/reports/src/modules/EfficiencyReport/components/subpages/SectionData/SuperChart';
import NumberMetaCard from '@nile/reports/src/modules/EfficiencyReport/components/subpages/NumberMetaCard';
import CustomDataTable from '@nile/reports/src/modules/EfficiencyReport/components/subpages/CustomDataTable';
import NumberCard from '../NumberMetaCard/NumberCard';
import CustomChart from './CustomChart';

function SectionData(props) {
  const {
    layoutData,
    condition,
    client,
    setClient,
    customReport = false
  } = props;

  const renderContent = (prop) => {
    switch (prop?.advancedChart?.defaultChartType) {
      case 'NUMBERCARD':
        return (
          <div className={`flex h91 full-width ${customReport ? '' : 'mt-30'}`}>
            {customReport ? (
              <NumberCard {...prop} condition={condition} />
            ) : (
              <NumberMetaCard {...prop} condition={condition} />
            )}
          </div>
        );
      case 'SUPERTABLE':
        return (
          <div
            className={`full-height full-width ${
              customReport ? 'p25' : 'mt-30'
            }`}
          >
            <CustomDataTable
              {...prop}
              condition={condition}
              client={client}
              setClient={setClient}
              dynamicRowCount={customReport}
              customReport={customReport}
            />
          </div>
        );
      case 'CUSTOMCHART':
        return (
          <div className="h91 full-width p20">
            <CustomChart {...prop} client={client} condition={condition} />
          </div>
        );
      case 'SUPERCHART':
        return (
          <div className="flex h91 full-width mt-30">
            <SuperChart {...prop} client={client} />
          </div>
        );
      default:
        return <></>;
    }
  };
  return (
    <div className={`mt10 ${customReport ? 'full-height' : ''}`}>
      {customReport ? (
        <>{renderContent(layoutData)}</>
      ) : (
        layoutData.map((l, i) => <>{renderContent(l)}</>)
      )}
    </div>
  );
}

export default SectionData;
